import { render, staticRenderFns } from "./tdComputePlats.vue?vue&type=template&id=25449a59&scoped=true&"
import script from "./tdComputePlats.vue?vue&type=script&lang=js&"
export * from "./tdComputePlats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25449a59",
  null
  
)

export default component.exports